import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        aria-label="Promedio"
        sx={{ color: '#6366f1' }}
        {...props}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{ color: 'text.secondary', fontWeight: 700 }}
        >
          {`${Math.round(props.value)}`}%
        </Typography>
        <Typography
          variant="body2"
          component="div"
          sx={{ color: 'text.secondary', fontWeight: 400 }}
        >
          Promedio
        </Typography>
      </Box>
    </Box>
  );
}

export default function CardResumenSimulador({promedio, mejorResultado, simuladoresCompletados}) {
  if(promedio === null || promedio === undefined || isNaN(promedio)) {
    return (<Typography>Cargando...</Typography>);
  }
  return (
    <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', borderRadius: 3, boxShadow: 3, p: 3 }}>
      <Typography sx={{ fontSize: "1rem", fontWeight: 700, letterSpacing: "-0.01em", color: "#0f172a", marginBottom: 2 }}>
        Promedio de resultados
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <CircularProgressWithLabel value={promedio} size={100} thickness={3} />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left', ml: 2 }}>
          <Typography variant="h5" component="div" sx={{ fontWeight: 700 }}>
            {simuladoresCompletados}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Simuladores completados
          </Typography>
          <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 700, mt: 1 }}>
            Promedio: {Math.round(promedio)}%
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Mejor resultado: <Box component="span" sx={{ color: 'success.main', fontWeight: 700 }}>
              {mejorResultado}%
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
